import { HttpClient } from '@angular/common/http';
import { Component, inject, type OnDestroy, type OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import * as InviteAccept from '../../../server/routes/invites/accept/post';
import * as InvitesGet from '../../../server/routes/invites/get';
import { AuthUserService } from '../auth-user.service';

@Component({
  selector: 'app-invite-accept',
  templateUrl: './invite-accept.component.html',
  styleUrls: ['./invite-accept.component.scss'],
  standalone: false,
})
export class InviteAcceptComponent implements OnDestroy, OnInit {
  private http = inject(HttpClient);
  private authUserService = inject(AuthUserService);

  loaded = false;
  invites: (InvitesGet.InviteResult & {
    accepted: boolean;
    waiting: boolean;
  })[] = [];
  subscriptions = new Subscription();

  ngOnInit(): void {
    this.http.get<InvitesGet.ResBody>('/api/invites').subscribe((invites) => {
      this.loaded = true;
      this.invites = invites.map((i) => ({
        ...i,
        accepted: false,
        waiting: false,
      }));
    });
  }

  dateString(createdAt: number) {
    return new Date(createdAt).toLocaleDateString();
  }

  acceptInvite(orgId: string) {
    const invite = this.invites.find((i) => i.orgId === orgId);
    if (!invite) return;

    const body: InviteAccept.ReqBody = { orgId };

    invite.waiting = true;
    this.http
      .post<InviteAccept.ResBody>('/api/invites/accept', body)
      .subscribe({
        next: (authResult) => {
          invite.waiting = false;
          invite.accepted = true;

          this.authUserService.processAcceptInvite(authResult);
        },
        error: (error) => {
          invite.waiting = false;
        },
      });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
